import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aba6d17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-3 m-auto chart" }

import { computed, onActivated, onDeactivated, ref } from "vue";
import { useRoute } from "vue-router";
import { useTargetStore } from "@/store/target.store";
import Button from "primevue/button";
import Chart from "primevue/chart";
import { TargetHistoryResponse } from "@evolutivelabs/quokka-common";
import { ScriptableLineSegmentContext } from "Chart.js";


const __default__ = {
  name: "TargetChart",
};

function setup(__props) {

const route = useRoute();
const targetStore = useTargetStore();
let id = route.params.id;

onActivated(async () => {
  id = route.params.id;
  await targetStore.fetch();

  if (typeof id === "string") {
    chartOriginData.value = await targetStore.fetchHistory(id);
  } else {
    throw new Error("init fail");
  }
});

onDeactivated(() => {
  chartOriginData.value = [];
});

const defaultChartData = {
  labels: [] as Date[],
  datasets: [
    {
      label: "",
      data: [] as number[],
    },
  ],
};

const chartOriginData = ref<TargetHistoryResponse[]>();
const skipped = (
  ctx: ScriptableLineSegmentContext,
  value: number[] | number
) => {
  return ctx.p0.skip || ctx.p1.skip ? value : undefined;
};

const chartData = computed(() => {
  if (chartOriginData.value === undefined) return;

  const valueData = chartOriginData.value?.map((e) => e.value);
  const timestampData = chartOriginData.value?.map((e) =>
    new Date(e.dateTime).getTime()
  );

  let i = 0;
  while (i < timestampData.length) {
    const oneHour = 3600000;
    const currentItem = timestampData[i];
    const nextItem = timestampData[i + 1];

    if (!currentItem || !nextItem) break;
    if (nextItem - currentItem !== oneHour) {
      timestampData.splice(i + 1, 0, currentItem + oneHour);
      valueData.splice(i + 1, 0, NaN);
    }
    i++;
  }

  return {
    labels: timestampData.map((e) => convertUTCDateToLocalDate(new Date(e))),
    datasets: [
      {
        label: targetStore.targets.filter((t) => t.id === id)[0]?.title,
        borderColor: "#2196F3",
        fill: true,
        tension: 0.1,
        data: valueData,
        segment: {
          borderDash: (ctx: ScriptableLineSegmentContext) =>
            skipped(ctx, [3, 3]),
          borderWidth: (ctx: ScriptableLineSegmentContext) => skipped(ctx, 2),
        },
      },
    ],
  };
});

const chartOptions = {
  plugins: {
    legend: {
      // prevent chart toggle by click legend
      onClick: null,
    },
  },
  scales: {
    x: {
      ticks: {
        // format mm-dd HH:MM
        callback: (value: number) => {
          const rowDateTime = chartData.value?.labels[value];
          if (rowDateTime === undefined) return;
          const date = new Date(rowDateTime);
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
          const day = String(date.getDate()).padStart(2, "0");
          const hour = String(date.getHours()).padStart(2, "0");
          return `${month}-${day} ${hour}:00`;
        },
      },
    },
  },
};

const convertUTCDateToLocalDate = (date: Date) => {
  const offset = date.getTimezoneOffset() / 60;
  const hours = date.getHours();
  return new Date(date.setHours(hours - offset));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Button), {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/targets'))),
      icon: "pi pi-arrow-left",
      label: "Back",
      class: "p-button-text ml-2 mb-2"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Chart), {
        type: "line",
        data: _unref(chartData) ?? defaultChartData,
        options: chartOptions
      }, null, 8, ["data"])
    ])
  ], 64))
}
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup})